import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';
import 'apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellComponent.css';
import BuySellOrderConfirmationModal from '../BuySellOrderConfirmationModal';
import BuySellTabs from 'apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellTabs';
import BuySellInstrumentSelector from 'apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellInstrumentSelector';
import BuySellOrderButton from 'apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellOrderButton';
import BuySellPresetValuesRows from 'apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellPresetValuesRows';
import BuySellCustomRow from 'apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellCustomRow';

const baseClasses = getBEMClasses('buy-sell');

export default class BuySellComponent extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    displayInstrumentSelector: PropTypes.bool,
    extraInfoComponent: PropTypes.element,
    themeModifier: PropTypes.string,
    amountHeader: PropTypes.string,
    formHeader: PropTypes.node,
    hideKYC: PropTypes.bool,
    customKYCmessage: PropTypes.string,
    submitting: PropTypes.bool.isRequired
  };

  static defaultProps = {
    displayInstrumentSelector: true,
    hideKYC: false,
    amountHeader: 'Amount'
  };

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const {
      handleSubmit,
      submitting,
      extraInfoComponent,
      displayInstrumentSelector,
      themeModifier,
      amountHeader,
      formHeader,
      hideKYC,
      customKYCmessage
    } = this.props;

    return (
      <form
        className={baseClasses('container', themeModifier)}
        onSubmit={handleSubmit}>
        {formHeader && (
          <div className={baseClasses('form-header', themeModifier)}>
            {formHeader}
          </div>
        )}
        <BuySellTabs baseClasses={baseClasses} themeModifier={themeModifier} />
        {displayInstrumentSelector && (
          <BuySellInstrumentSelector baseClasses={baseClasses} />
        )}
        {amountHeader && (
          <div className={baseClasses('amount-header', themeModifier)}>
            {this.context.t(amountHeader)}
          </div>
        )}
        <div className={baseClasses('amount-container', themeModifier)}>
          <BuySellPresetValuesRows baseClasses={baseClasses} />
          <BuySellCustomRow
            baseClasses={baseClasses}
            themeModifier={themeModifier}
          />
          <BuySellOrderConfirmationModal />
        </div>
        {extraInfoComponent && (
          <div
            className={baseClasses('extra-info-container', themeModifier)}>
            {extraInfoComponent}
          </div>
        )}
        <BuySellOrderButton
          baseClasses={baseClasses}
          handleSubmit={handleSubmit}
          submitting={submitting}
          hideKYC={hideKYC}
          customKYCmessage={customKYCmessage}
        />
      </form>
    );
  }
}
